import Vue from "vue";
import Router from "vue-router";

const index = () => import("../page/index"); //商城首页
const login = () => import("../page/login"); //登录注册页
const newpassword = () => import("../page/newpassword"); //修改密码页
const claproducts = () => import("../page/claproducts"); //品牌中心
const gallery = () => import("../page/gallery/components/searchGoodsIndex"); //商城分类首页
const merchant = () => import("../page/merchant/components/searchStoresIndex"); //商户分类首页
const futuresIndex = () => import("../page/futuresIndex/index"); //期货指数
const futuresIndexDetail = () => import("../page/futuresIndex/detail"); //期货指数文章详情
const giftgoods = () => import("../page/giftgoods"); //配赠商品详情页
const goodsdetail = () => import("../page/goodsdetail"); //商品详情页
const shopcar = () => import("../page/shopcar"); //购物车页面
const order = () => import("../page/order"); //核对订单页面
const pay = () => import("../page/pay"); //支付页面
const mergePay = () => import("../page/pay/mergePay"); // 合单页面
const mineIndex = () => import("../page/mine"); //会员中心页面
const settleIndex = () => import("../page/settleIn"); //会员中心页面
const authcenter = () => import("../page/authcenter"); //店铺认证页面
const abapply = () => import("../page/abapply"); //加盟商申请页面
const mineorder = () => import("../page/mineorder"); //我的订单页面
const auction = () => import("../page/auction"); //我的拍卖页面
const personalCommunity = () => import("../page/personalCommunity"); //我的订单页面
const penMes = () => import("../page/mine/comm/penMes"); //个人信息
const orderdetail = () => import("../page/orderdetail"); //订单详情页页面
const goodsreturn = () => import("../page/goodsreturn/goodsreturn"); //退货
const userinfo = () => import("../page/userinfo"); //会员中心页面
const useraddress = () => import("../page/useraddress"); //收货地址页面
const material = () => import("../page/material"); //我的素材页面
const matelibrary = () => import("../page/matelibrary"); //素材库页面
const metadetail = () => import("../page/metadetail"); //素材库详情页面
const newslibrary = () => import("../page/newslibrary"); //新闻页面
const industrynews = () => import("../page/industrynews"); //新闻页面
const industrydetail = () => import("../page/industrydetail"); //新闻页面
const mycomment = () => import("../page/mycomment"); //我的评论页面
const returngoods = () => import("../page/returngoods"); //我的退货退款
const commentdetail = () => import("../page/commentdetail"); //我的评论详情页面
const mybalance = () => import("../page/mybalance"); //我的余额页面
const mycoupon = () => import("../page/mycoupon"); //我的优惠券页面
const myintegral = () => import("../page/myintegral"); //我的积分页面
const mycollect = () => import("../page/mycollect"); //我的收藏页面
const retailsale = () => import("../page/retailsale"); //我的分销页面
const subaccount = () => import("../page/subaccount"); //子账户管理页面
const newsdetail = () => import("../page/newsdetail"); //新闻详情页面
const recharge = () => import("../page/recharge"); //充值中心页面
const rechargescore = () => import("../page/rechargescore"); //积分充值中心页面
const rechargepay = () => import("../page/rechargepay"); //充值支付页面
const article = () => import("../page/article"); //帮助中心
const community = () => import("../page/community"); //社区中心\
const auctionCentre = () => import("../page/auctionCentre"); //拍卖中心
const auctionDetail = () => import("../page/auctionDetail"); //拍卖详情页面
const communitynew = () => import("../page/communitynew"); //发布新话题页面
const communitydetail = () => import("../page/communitydetail"); //社区话题详情页面
const groupbuy = () => import("../page/groupbuy/groupbuy"); //集采页面
const changepassword = () => import("../page/changepassword"); //个人中心修改密码页面
const minecard = () => import("../page/minecard/minecard"); //我的银行卡
const quickBindBank = () => import("../page/quickBindBank/quickBindBank"); //我的银行卡
const cashier = () => import("../page/recharge/cashier"); //支付
const reconciliation = () => import("../page/reconciliation"); //对账报表
const minecardnumber = () => import("../page/minecardnumber/minecardnumber"); //我的银行卡号
const act = () => import("../page/activity/activity"); //活动页
const contactUs = () => import("../page/contactUs"); //联系我们\
// 统计报表
const buyTotal = () => import("../page/statement/buyTotal"); // 采购汇总
const buyDetail = () => import("../page/statement/buyDetail"); // 采购汇总

const giveProduct = () => import("../page/mybalance/giveProduct"); // 充值有礼赠送商品

// const goodsList = () =>
// 	import('../page/goods/goodsList/list.vue') // 商品列表

const invoicesList = () => import("../page/invoices/invoicesList"); // 开票记录
const prefectureGoods = () => import("../page/mine/prefectureGoods/index"); // 商品专区
Vue.use(Router);
//replace多次点击相同链接报错 push就是将replace改成push
//const originalReplace = VueRouter.prototype.replace
//VueRouter.prototype.replace = function replace(location) {
//return originalReplace.call(this, location).catch(err => err)
//}
//
//const originalPush = VueRouter.prototype.push
//VueRouter.prototype.push = function push(location) {
//return originalPush.call(this, location).catch(err => err)
//}

export const asyncRoutes = [
    {
        path: "/mine",
        name: "mine",
        component: mineIndex,
        meta: {
            title: "会员中心首页",
            menuCode: "A1"
        },
        hidden: true
    },
    {
        path: "/settleIn",
        name: "settleIn",
        component: settleIndex,
        meta: {
            title: "商家入驻",
            menuCode: "A2"
        },
        hidden: true
    },
    {
        path: "/mine",
        name: "mine",
        component: mineIndex,
        meta: {
            title: "会员中心",
            menuCode: "A100",
            parentCode: "A100"
        },
        hidden: true
    },
    {
        path: "/shopcar",
        name: "shopcar",
        component: shopcar,
        meta: {
            title: "购物车",
            menuCode: "B100"
        },
        hidden: true
    },
    {
        path: "/mineorder",
        component: mineorder,
        name: "mineorder",
        meta: {
            title: "我的订单",
            menuCode: "B100",
            parentCode: "B100"
        }
    },
    {
        path: "/auction",
        component: auction,
        name: "auction",
        meta: {
            title: "我的拍卖",
            menuCode: "B100",
            parentCode: "B100"
        }
    },
    {
        path: "/penMes",
        component: penMes,
        name: "penMes",
        meta: {
            title: "修改个人资料",
            menuCode: "PP1",
            parentCode: "P1"
        }
    },
    {
        path: "/afterSale",
        component: () => import("@/page/mine/afterSale/index"),
        name: "afterSale",
        meta: {
            title: "退/售后",
            menuCode: "PP1111"
        }
    },
    {
        path: "/afterApply",
        component: () => import("@/page/mine/afterSale/apply"),
        name: "afterApply",
        meta: {
            title: "售后申请",
            menuCode: "PP1111"
        }
    },
    {
        path: "/afterSaleDetail",
        component: () => import("@/page/mine/afterSale/detail"),
        name: "afterSaleDetail",
        meta: {
            title: "售后详情",
            menuCode: "PP1111"
        }
    },
    {
        path: "/afterSaleCollect",
        component: () => import("@/page/mine/afterSale/collect"),
        name: "afterSale",
        meta: {
            title: "我的收藏",
            menuCode: "A100",
            parentCode: "A100"
        }
    },
    {
        path: "/applyGoods",
        component: () => import("@/page/applyGoods/index"),
        name: "applyGoods",
        hiddenSystem: "yokelly.cs",
        meta: {
            title: "要货申请",
            menuCode: "PP112",
            parentCode: "P1"
        }
    },
    {
        path: "/purchase",
        component: () => import("@/page/purchase/index"),
        name: "purchase",
        hiddenSystem: "yokelly.cs",
        meta: {
            title: "采购管理",
            menuCode: "PP113",
            parentCode: "P1"
        }
    },
    {
        path: "/purchase/pay",
        component: () => import("@/page/purchase/pay"),
        name: "purchasePay",
        hidden: true,
        meta: {
            title: "采购管理-支付",
            menuCode: "PP113"
        }
    },
    // {
    // 	path: '/returngoods',
    // 	component: returngoods,
    // 	name: 'returngoods',
    // 	meta: {
    // 		title: '退货退款',
    // 		menuCode: 'PP1111',
    // 		parentCode: 'P1'
    // 	}
    // },
    {
        path: "/mycomment",
        component: mycomment,
        name: "mycomment",
        meta: {
            title: "我的评论",
            menuCode: "PP2",
            parentCode: "P1"
        }
    },
    {
        path: "/invoicesList",
        component: invoicesList,
        name: "invoicesList",
        hiddenSystem: "yokelly.cs",
        meta: {
            title: "我的发票",
            menuCode: "PP17",
            parentCode: "P1"
        }
    },
    {
        path: "/prefectureGoods",
        component: prefectureGoods,
        name: "prefectureGoods",
        meta: {
            title: "商品专区",
            menuCode: "P104",
            parentCode: "P1"
        }
    },
    {
        path: "/record",
        name: "record",
        component: mybalance,
        meta: {
            title: "充值记录",
            menuCode: "PP3",
            parentCode: "P2"
        }
    },
    {
        path: "/mybalance",
        component: mybalance,
        name: "mybalance",
        meta: {
            title: "我的余额",
            menuCode: "PP4",
            parentCode: "P2"
        }
    },
    {
        path: "/reconciliation",
        component: reconciliation,
        name: "reconciliation",
        meta: {
            title: "对账报表",
            menuCode: "PP4",
            parentCode: "P2"
        }
    },
    {
        path: "/mycoupon",
        component: mycoupon,
        name: "mycoupon",
        meta: {
            title: "我的优惠券",
            menuCode: "PP5",
            parentCode: "P2"
        }
    },

    {
        path: "/subaccount",
        name: "subaccount",
        component: subaccount,
        meta: {
            title: "账号管理",
            menuCode: "PP6",
            parentCode: "P3"
        }
    },
    {
        path: "/branchstore",
        name: "branchStore",
        component: () => import("@/page/branchStore/index"),
        meta: {
            title: "分店信息",
            menuCode: "PP61",
            parentCode: "P3"
        }
    },
    {
        path: "/minecard",
        component: minecard,
        name: "minecard",
        meta: {
            title: "转款绑卡",
            menuCode: "PP11",
            parentCode: "P3"
        }
    },
    // {
    // 	path: '/minecardnumber',
    // 	component: minecardnumber,
    // 	name: 'minecardnumber',
    // 	meta: {
    // 		title: '我的银行卡号',
    // 		menuCode: 'PP11',
    // 		parentCode: 'P3'
    // 	}
    // },
    {
        path: "/quickBindBank",
        component: quickBindBank,
        name: "quickBindBank",
        meta: {
            title: "快捷绑卡",
            menuCode: "PP11",
            parentCode: "P3"
        }
    },
    {
        path: "/changepassword",
        name: "changepassword",
        component: changepassword,
        meta: {
            title: "修改密码",
            menuCode: "PP7",
            parentCode: "P3"
        }
    },
    {
        path: "/useraddress",
        name: "useraddress",
        component: useraddress,
        meta: {
            title: "收货地址",
            menuCode: "A100",
            parentCode: "A100"
        }
    },
    {
        path: "/personalCommunity",
        name: "personalCommunity",
        component: personalCommunity,
        meta: {
            title: "收货地址",
            menuCode: "A100",
            parentCode: "A100"
        }
    },
    {
        path: "/userinfo/store",
        name: "store",
        component: userinfo,
        meta: {
            title: "店铺信息",
            menuCode: "PP9",
            parentCode: "P3"
        }
    },
    {
        path: "/userinfo/league",
        name: "league",
        component: userinfo,
        meta: {
            title: "加盟信息",
            menuCode: "PP10",
            parentCode: "P3"
        }
    },
    // {
    // 	path: '/userinfo/invoices',
    // 	name: 'invoices',
    // 	component: () => import('@/page/invoices'),
    // 	meta: {
    // 		title: '发票主体',
    // 		menuCode: 'PP11',
    // 		parentCode: 'P3'
    // 	}
    // },
    //	{
    //		path: '/retailsale',
    //		name: 'retailsale',
    //		component: retailsale,
    //		meta: {
    //			title: '我的分销',
    //			menuCode: 'PP13',
    //			parentCode: 'P4'
    //		}
    //	},
    {
        path: "/mycollect",
        name: "mycollect",
        component: mycollect,
        meta: {
            title: "收藏商品",
            menuCode: "A4",
            parentCode: "A4"
        }
    },
    {
        path: "/material",
        name: "material",
        component: material,
        meta: {
            title: "我的素材",
            menuCode: "PP13",
            parentCode: "P5"
        }
    },
    {
        path: "/recharge",
        name: "recharge",
        component: recharge,
        meta: {
            title: "充值中心",
            menuCode: "P9"
        },
        hidden: true
    },
    {
        path: "/rechargescore",
        name: "rechargescore",
        component: rechargescore,
        meta: {
            title: "积分充值中心",
            menuCode: "P9"
        },
        hidden: true
    },
    {
        path: "/orderdetail",
        name: "orderdetail",
        component: orderdetail,
        meta: {
            title: "订单详情",
            menuCode: "A2",
            parentCode: "A2"
        },
        hidden: true
    },
    // {
    // 	path: '/order',
    // 	name: 'order',
    // 	component: order,
    // 	meta: {
    // 		title: '订单结算',
    // 		menuCode: 'P6'
    // 	},
    // 	hidden: true
    // },
    {
        path: "/order/consignment",
        component: () => import("@/page/order/consignment"),
        name: "consignment",
        meta: {
            title: "订单结算-代发订单",
            menuCode: "P6"
        },
        hidden: true
    },
    {
        path: "/pay",
        name: "pay",
        component: pay,
        meta: {
            title: "订单支付",
            menuCode: "P7"
        },
        hidden: true
    },
    {
        path: "/mergePay",
        name: "mergePay",
        component: mergePay,
        meta: {
            title: "合单支付",
            menuCode: "P7"
        },
        hidden: true
    },
    {
        path: "/rechargepay",
        name: "rechargepay",
        component: pay,
        meta: {
            title: "充值支付",
            menuCode: "P10"
        },
        hidden: true
    },
    {
        path: "/buyTotal",
        name: "buyTotal",
        component: buyTotal,
        meta: {
            title: "采购汇总",
            menuCode: "PP14",
            parentCode: "P14"
        }
    },
    {
        path: "/buyDetail",
        name: "buyDetail",
        component: buyDetail,
        meta: {
            title: "采购明细",
            menuCode: "PP15",
            parentCode: "P14"
        }
    },
    {
        path: "/giveProduct",
        name: "giveProduct",
        component: giveProduct,
        meta: {
            title: "赠送商品",
            menuCode: "PP16",
            parentCode: "P2"
        }
    }
];
export const constantRoutes = [
    {
        path: "/login",
        name: "login",
        component: login
    },
    {
        path: "/order",
        name: "order",
        component: order,
        meta: {
            title: "订单结算",
            menuCode: "P6"
        },
        hidden: true
    },
    {
        path: "/pay",
        name: "pay",
        component: pay,
        meta: {
            title: "订单支付",
            menuCode: "P6"
        },
        hidden: true
    },
    {
        path: "/orderdetail",
        name: "orderdetail",
        component: orderdetail,
        meta: {
            title: "订单详情",
            menuCode: "P6"
        },
        hidden: true
    },
    {
        path: "/merchant",
        name: "merchant",
        component: merchant,
        meta: {
            title: "商户列表",
            menuCode: "A2"
        },
        hidden: true
    },
    {
        path: "/",
        name: "index",
        component: index
    },
    {
        path: "/newpassword",
        name: "newpassword",
        component: newpassword
    },
    {
        path: "/newsdetail",
        name: "newsdetail",
        component: newsdetail
    },
    {
        path: "/act",
        name: "act",
        component: act
    },
    {
        path: "/gallery",
        name: "gallery",
        component: gallery
    },
    {
        path: "/futuresIndex",
        name: "futuresIndex",
        component: futuresIndex
    },
    {
        path: "/futuresIndexDetail",
        name: "futuresIndexDetail",
        component: futuresIndexDetail
    },
    {
        path: "/gallery/:name",
        name: "gallery",
        component: gallery
    },
    {
        path: "/404",
        component: () => import("@/page/error-page/404"),
        hidden: true
    },
    {
        path: "/401",
        component: () => import("@/page/error-page/401"),
        hidden: true
    },
    {
        path: "/claproducts",
        name: "claproducts",
        component: claproducts
    },
    {
        path: "/giftgoods",
        name: "giftgoods",
        component: giftgoods
    },
    {
        path: "/activity",
        name: "activity",
        component: groupbuy
    },
    {
        path: "/newslibrary",
        name: "newslibrary",
        component: newslibrary
    },
    {
        path: "/industrynews",
        name: "industrynews",
        component: industrynews
    },
    {
        path: "/industrydetail",
        name: "industrydetail",
        component: industrydetail
    },
    {
        path: "/matelibrary",
        name: "matelibrary",
        component: matelibrary
    },
    {
        path: "/metadetail",
        name: "metadetail",
        component: metadetail
    },
    {
        path: "/barandDetail/:id",
        name: "barandDetail",
        component: () => import("@/page/matelibrary/brandDetail")
    },
    {
        path: "/commentdetail",
        name: "commentdetail",
        component: commentdetail
    },
    {
        path: "/article",
        name: "article",
        component: article
    },
    {
        path: "/community",
        name: "community",
        component: community
    },{
        path: "/auctionCentre",
        name: "auctionCentre",
        component: auctionCentre
    },
    ,{
        path: "/auctionDetail",
        name: "auctionDetail",
        component: auctionDetail
    },
    {
        path: "/communitynew",
        name: "communitynew",
        component: communitynew
    },
    {
        path: "/contactUs",
        name: "contactUs",
        component: contactUs
    },
    {
        path: "/communitydetail",
        name: "communitydetail",
        component: communitydetail
    },
    {
        path: "/goodsreturn",
        name: "goodsreturn",
        component: goodsreturn
    },
    {
        path: "/goodsdetail",
        name: "goodsdetail",
        component: goodsdetail
    },
    {
        path: "/cashier",
        name: "cashier",
        component: cashier
    },
    {
        path: "/notice",
        name: "notice",
        component: () => import("@/page/notice/index"),
        meta: {
            title: "商城通知"
        }
    },
    {
        path: "/noticeDetail",
        name: "noticeDetail",
        component: () => import("@/page/notice/detail"),
        hidden: true,
        meta: {
            title: "商城通知详情"
        }
    }
    // {
    // 	path: '/goodsList',
    // 	name: 'goodsList',
    // 	component: goodsList
    // }
];

const createRouter = () =>
    new Router({
        // mode: 'history', // require service support
        scrollBehavior: () => ({
            y: 0
        }),
        routes: constantRoutes
    });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}

export default router;
